export default __webpack_public_path__ + "static/media/about-us.1c00688d.png";